export const fonts = {
  sizes: {
    verySmall: "10px",
    extraSmall: "12px",
    small: "14px",
    regular: "16px",
    medium: "18px",
    big: "20px",
    large: "22px",
    h5: "24px",
    "h4.5": "26px",
    h4: "28px",
    h3: "32px",
    "h3.4": "34px",
    "h3.6": "36px",
    h2: "48px",
    "h2.1": "40px",
    h1: "64px",
  },
  families: {
    primary: "Poppins, -apple-system, Roboto, Helvetica, sans-serif",
    secondary: "Montserrat, sans-serif",
  },
}
